<template>
  <div class="container">
    <div class="signature-canvas-wrapper">
      <canvas
        id="signature-canvas"
        ref="editor"
        width="860"
        height="300"
      />
    </div>

    <div class="actions">
      <div>
        <el-button
          v-if="!signatureImageUrl"
          type="default"
          @click="onClickClearEditor"
        >
          消す
        </el-button>
      </div>

      <div>
        <el-button
          @click="onClickClose"
        >
          閉じる
        </el-button>

        <el-button
          v-if="!signatureImageUrl && isEditable"
          type="primary"
          class="CharacterSubmit"
          @click="onClickSubmit"
        >
          確定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric";
import FileUsecase from "@/usecases/file.usecase";

// 引数はbase64形式の文字列と作成するファイルオブジェクトのファイル名
const createJpegFile4Base64 = (base64, name) => {
  // base64のデコード
  const bin = atob(base64.replace(/^.*,/, ""));

  // バイナリデータ化
  const buffer = new Uint8Array(bin.length);

  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }

  // ファイルオブジェクト生成(この例ではjpegファイル)
  return new File([buffer.buffer], name, { type: "image/jpeg" });
};

export default {
  name: "CommonMySignatureEditor",
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    signature: {
      type: String,
      default: null,
    },
    signatureImageUrl: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      editor: null,
      canvas: null,
      result: "",
      results: [],
    };
  },
  created () {
  },
  async mounted () {
    if (!this.isEditable) {
      return;
    }

    this.initialize();
  },
  methods: {
    /**
     * [initialize description]
     * @return  {[type]}  [return description]
     */
    initialize () {
      // キャンバス要素の取得
      const editor = this.$refs.editor;

      if (!editor) {
        this.$notify.error({
          title: "エラー - サイン",
          message: "キャンバス要素が見つかりません。初期化に失敗しました。",
        });

        return;
      }

      this.canvas = new fabric.Canvas(editor, {
        isDrawingMode: true,
        width: 860,
        height: 300,
        backgroundColor: "white",
      });

      this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
      this.canvas.freeDrawingBrush.width = 2;
    },

    /**
     * [onClickClearEditor description]
     * @return  {[type]}  [return description]
     */
    onClickClearEditor () {
      this.canvas.clear();
      this.canvas.backgroundColor = "white";
      this.canvas.renderAll();
    },

    /**
     * [onClickClose description]
     * @return  {[type]}  [return description]
     */
    onClickClose () {
      this.$emit("onClose");
    },

    /**
     * [onClickSubmit description]
     * @return  {[type]}  [return description]
     */
    async onClickSubmit () {
      try {
        const file = this.createFile();

        const { name } = file;

        // 保存する画像のカテゴリを分ける
        const category = "signature";

        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, file);

        this.$emit("onSubmit", result.key);
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * [createFile description]
     * @return  {[type]}  [return description]
     */
    createFile () {
      const dataURL = this.canvas.toDataURL({
        format: "jpeg",
        quality: 1,
        multiplier: 1,
      });

      const file = createJpegFile4Base64(dataURL, "text.jpg");

      // アップロード時のファイルサイズ制限
      // default: 3MB まで
      if (!usecase.file.validateFileSize(file)) {
        const message = "ファイルサイズが大きすぎます。3MB以下のファイルをアップロードしてください。";

        this.$notify.error({
          title: "エラー - サイン",
          message,
        });

        throw new Error("File size exceeds limit, not uploading.");
      }

      return file;
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.signature-canvas-wrapper {
  height: 300px;
  width: 860px;
  border: 1px solid $--border-color-light;
}

.canvas {
  height: 300px;
  width: 860px;
}

.actions {
  padding: 10px 0;
  text-align: right;
  display: flex;
  justify-content: space-between;
}
</style>
